import { render, staticRenderFns } from "./PermissionsSalesForm.vue?vue&type=template&id=2b097b46&scoped=true&"
import script from "./PermissionsSalesForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsSalesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b097b46",
  null
  
)

export default component.exports